import { Label as BaseLabel } from '@qga/roo-ui/components';
import styled from '@emotion/styled';

// We have to override the default roo-ui label to remove the margin bottom;
const Label = styled(BaseLabel)`
  margin-bottom: 0;
`;

export default Label;
